<mat-list class="text-align-left">
    <ng-container *ngFor="let doc of documents; let docIdx = index">

         <mat-list-item id="{{idPrefix}}item_{{docIdx}}"
                        class="row no-gutters"
                        [ngClass]="{ 'placeholder': doc.is_placeholder, 'placeholder-has-links': doc.is_placeholder && asDistributionPlaceholder(doc).placeholder_links.length }">

              <!-- FIRST COLUMN: START -->
              <div class="col-sm-1 column-icon" [align]="'middle'" style="padding: 0;" *ngIf="!doc.workflow_id && !doc.is_placeholder">
                  <mat-spinner matListAvatar *ngIf="jobState === DistributionJobState.PREPARING_SCHEDULED" [diameter]="18"></mat-spinner>

                  <ng-container *ngIf="jobState !== DistributionJobState.PREPARING_SCHEDULED">
                      <i matListAvatar
                         style="top: 0;"
                         *ngIf="doc.document_type !== CaseFileCategories.CLAIM_IMAGE"
                         class="dr-fa-icon far {{ doc.state === DistributionDocState.ERROR ? 'fa-file-excel' : (doc.state === DistributionDocState.READY ? doc.fileType.faClass : viewFileIcon) }} fa-lg"
                         [ngClass]="{ 'iq-color-warn-light': doc.state === DistributionDocState.ERROR }"
                         (click)="showFile(doc)">
                      </i>

                      <div class="image-container"
                           *ngIf="doc.document_type === CaseFileCategories.CLAIM_IMAGE">
                          <select-thumb-nail [idPrefix]="(idPrefix + 'item_' + docIdx)"
                                             [file]="doc"
                                             [forList]="true"
                                             (click)="showFile(doc)">
                          </select-thumb-nail>
                      </div>
                  </ng-container>
              </div>

              <!-- FIRST COLUMN: END -->


              <!-- SECOND COLUMN: START -->

              <div class="column-display-name" [ngClass]="{'col-sm-10': doc.workflow_id, 'col-sm-6': !doc.workflow_id && doc.is_placeholder, 'col-sm-5': !doc.workflow_id && !doc.is_placeholder}">
                  <span matLine [ngClass]="{ 'iq-color-warn-light': doc.state === DistributionDocState.ERROR }">
                      {{ doc.is_placeholder ? (('detailed_processing.distribution.label.placeholder' | translate | titlecase ) + ': ' + (CaseFileCategory[doc.document_type].trans | translate)) : doc.display_name }}
                  </span>
              </div>

              <!-- SECOND COLUMN: END -->


              <!-- THIRD COLUMN: START -->
              <div class="col-sm-3 column-date" *ngIf="!doc.workflow_id">
                  <div class="mt-2" *ngIf="doc.is_template">
                      <mat-form-field [floatLabel]="'never'" [appearance]="'fill'">
                          <input id="{{idPrefix}}item_{{docIdx}}.{{doc.trans.document_date}}"
                                 matInput [matDatepicker]="picker"
                                 placeholder="{{ doc.trans.document_date | translate }}"
                                 [(ngModel)]="doc.document_date"
                                 (dateChange)="updateDistributionDocument(doc)"
                                 [disabled]="disabled">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                  </div>
              </div>

              <!-- THIRD COLUMN: END -->


              <!-- FOURTH COLUMN: START -->
              <div class="col-sm-2 column-copy" align="center" *ngIf="!doc.workflow_id">
                  <div class="mt-2 pt-1" *ngIf="doc.is_template">
                      <mat-checkbox *ngIf="doc.state === DistributionDocState.INITIAL && doc.document_type === CaseFileCategories.MAIN_DOCUMENT"
                                    id="{{idPrefix}}item_{{docIdx}}.{{doc.trans.copy}}"
                                    [(ngModel)]="doc.copy"
                                    [labelPosition]="'before'"
                                    (change)="updateDistributionDocument(doc)"
                                    [disabled]="disabled">
                          {{ doc.trans.copy | translate }}
                      </mat-checkbox>
                  </div>

              </div>

              <!-- FOURTH COLUMN: END -->

              <!-- FIFTH COLUMN: START -->

              <div class="col column-remove" [align]="'right'">
                  <button mat-icon-button
                          id="{{idPrefix}}item_{{docIdx}}.btn.remove"
                          (click)="deleteFile(doc)"
                          [disabled]="disabled">
                      <mat-icon class="dr-material-icon"
                                [ngClass]="{ 'disabled': disabled }"
                                matTooltip="{{ 'common.label.delete' | translate }}">clear
                      </mat-icon>
                  </button>
              </div>
              <!-- FIFTH COLUMN: END -->

         </mat-list-item>

         <ng-container *ngIf="doc.is_placeholder">
             <mat-list-item class="row no-gutters placeholder-link"
                            *ngFor="let link of asDistributionPlaceholder(doc).placeholder_links; let last = last; let linkIdx = index"
                            [ngClass]="{'last': last}">
                 <!-- FIRST COLUMN: START -->
                 <div class="col-sm-1 column-icon" [align]="'middle'" style="padding: 0;">
                     <mat-spinner matListAvatar *ngIf="jobState === DistributionJobState.PREPARING_SCHEDULED" [diameter]="18"></mat-spinner>

                     <ng-container *ngIf="jobState !== DistributionJobState.PREPARING_SCHEDULED">
                          <i matListAvatar
                             id="{{idPrefix}}item_{{docIdx}}.link_{{linkIdx}}"
                             style="top: 0;"
                             *ngIf="doc.document_type !== CaseFileCategories.CLAIM_IMAGE"
                             class="dr-fa-icon far {{ link.state === DistributionDocState.ERROR ? 'fa-file-excel' : (link.state === DistributionDocState.READY ? doc.fileType.faClass : viewFileIcon) }} fa-lg"
                             [ngClass]="{ 'iq-color-warn-light': link.state === DistributionDocState.ERROR }"
                             (click)="showFile(link)">
                         </i>

                         <div class="image-container"
                              *ngIf="doc.document_type === CaseFileCategories.CLAIM_IMAGE">
                             <select-thumb-nail [idPrefix]="(idPrefix + 'item_' + docIdx + '.link_' + linkIdx)"
                                                [file]="link"
                                                [forList]="true"
                                                (click)="showFile(link)">
                             </select-thumb-nail>
                         </div>
                     </ng-container>
                 </div>

                 <!-- FIRST COLUMN: END -->


                 <!-- SECOND COLUMN: START -->

                 <div class="col-sm-10 column-display-name">
                     <span matLine [ngClass]="{ 'iq-color-warn-light': doc.state === DistributionDocState.ERROR }">
                          {{ link.display_name }}
                     </span>
                 </div>

                 <!-- SECOND COLUMN: END -->

                 <!-- THIRD COLUMN: START -->

                 <div class="col-sm-1 column-remove" [align]="'right'">
                     <button mat-icon-button
                             id="{{idPrefix}}item_{{docIdx}}.link_{{linkIdx}}.btn.remove"
                             *ngIf="jobState !== DistributionJobState.INITIAL"
                             (click)="deleteFile(link)"
                             [disabled]="disabled">
                         <mat-icon class="dr-material-icon"
                                   [ngClass]="{ 'disabled': disabled }"
                                   matTooltip="{{ 'common.label.delete' | translate }}">clear
                         </mat-icon>
                     </button>
                 </div>
                 <!-- THIRD COLUMN: END -->

             </mat-list-item>
         </ng-container>

    </ng-container>

</mat-list>
